module.exports = function(ip) {
  var _ip = ip.split('::ffff:')
  if (_ip.length > 1) {
    return _ip[1]
  }
  return ip
}
